import { routes } from '../lib';

const pathJoin = (...parts: (string | number | undefined)[]) => {
  return parts
    .filter(Boolean)
    .map((p) => String(p).replace(/\/+$/, '')) // убираем хвостовые /
    .join('/')
    .replace(/\/{2,}/g, '/')
    .replace(/^(?=[^/])/, '/');
};

class RoutesBuilder {
  private parts: string[] = [];
  private liveFlag = false;

  meetingGroup(id: string) {
    this.parts.push(pathJoin(routes.MEETING_GROUP, id));
    return this;
  }

  server(id: string) {
    this.parts.push(pathJoin(routes.SERVERS, id));
    return this;
  }

  session(id: string) {
    this.parts.push(pathJoin(routes.SESSIONS, id));
    return this;
  }

  voiceChannel(id: string) {
    this.parts.push(pathJoin(routes.DISCORD_VOICES, id));
    return this;
  }

  live() {
    this.liveFlag = true;
    return this;
  }

  build() {
    const base = pathJoin(...this.parts);
    return this.liveFlag ? pathJoin(base, 'live') : base;
  }
}

export const routesBuilder = () => new RoutesBuilder();

/**
 * Получение маршрута сессии сервера по ID
 */
export const getServerSessionRoute = (id: string) => routesBuilder().server(id).build();

/**
 * Получение детального маршрута сессии (включая /live, если активна)
 */
export const getSessionDetailedRoute = (
  meetingGroupId: string,
  serverId: string,
  sessionId: string,
  status: 'active' | 'inactive' | string,
) => {
  const builder = routesBuilder().meetingGroup(meetingGroupId).server(serverId).session(sessionId);

  return status === 'active' ? builder.live().build() : builder.build();
};

/**
 * Получение маршрута голосового канала Discord
 */
export const getVoiceChannelsRoute = (id: string) => routesBuilder().voiceChannel(id).build();

/**
 * Получение маршрута Meeting Group по ID
 */
export const getMeetingGroupByIdRoute = (id: string) => routesBuilder().meetingGroup(id).build();

/**
 * Получение списка серверов Discord для Meeting Group
 */
export const getDiscordServersRoute = (guildId: string) =>
  pathJoin(getMeetingGroupByIdRoute(guildId), 'workspace');

/**
 * Получение маршрута голосовых каналов Discord внутри Meeting Group
 */
export const getDiscordVoicesRoute = (guildId: string, meetingGroupById: string) =>
  pathJoin(getMeetingGroupByIdRoute(guildId), routes.DISCORD_VOICES, meetingGroupById);

export const getActiveConversationsRoute = () => '/active-conversations';
